<template>
  <section class="news-container">
    <el-tabs
      v-model="activeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-select
            v-model="destination"
            placeholder="All Destinations"
            :list="destinationsList"
            @change="filterData" />
          <!-- <v-select
            v-model="order"
            placeholder="Start Date"
            :list="orderList"
            @change="filterData" /> -->
        </div>
        <div>
          <v-button
            type="primary" 
            @click="onNewBanner">New Banner</v-button>
        </div>
      </div>

      <div class="transparent">
        <banner-list
          ref="banner-list"
          :activeTab="activeTab"
          :destination="destination" />
      </div>

      <!-- <div class="transparent">
        <el-table
          :data="bannersData"
          stripe
          style="width: 100%"
          @row-click="handlerRowClick">
          <el-table-column
            label="Preview">
            <template slot-scope="scope">
              <img
                :src="scope.row.banner_url"
                alt="banner"
                class="img-banner" />
            </template>
          </el-table-column>
          <el-table-column
            label="Destination">
            <template slot-scope="scope">
              <span>{{ getOptionName('productTypeOptions', scope.row.product_id) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="Start Date" />
          <el-table-column
            prop="end_time"
            label="End Date" />
          <el-table-column
            v-if="activeTab == '1'"
            label="Order"
            width="80">
            <template slot-scope="scope">
              <div class="btn-list">
                <span
                  class="pointer ic-order text-center"
                  @click.stop="handlerOrder(scope.$index)">
                  <font-awesome-icon icon="arrow-up" />
                </span>
                <span
                  class="pointer ic-order text-center"
                  @click.stop="handlerOrder(scope.$index)">
                  <font-awesome-icon icon="arrow-down" />
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
    </div>

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import BannerList from '../banner-list'

export default {
  name: 'BannerContainer',
  components: {
    BannerList
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      activeTab: '1',
      tabList: [
        {
          name: '1',
          label: 'Current Banners'
        },
        {
          name: '2',
          label: 'Upcoming'
        },
        {
          name: '3',
          label: 'Past'
        },
      ],
      bannersData: [],
      destinationsList: [
        {
          id: 'product',
          name: 'Product'
        },
        {
          id: 'url',
          name: 'Url'
        },
        {
          id: 'all',
          name: 'All Destinations'
        },
      ],
      // orderList: [
      //   {
      //     id: 'start_time',
      //     name: 'Start Date'
      //   },
      //   {
      //     id: 'end_time',
      //     name: 'End Date'
      //   }
      // ],
      destination: 'all',
      // order: 'start_time'
    }
  },
  computed: {
    
  },
  methods: {
    filterData() {
      // this.$refs['banner-list'].handlerUpdate()
    },
    handlerOrder(index) {
      // next_advert_id, prev_advert_id, advert_id
      const len = this.bannersData.length
      if(len == 1) return // 只有一條記錄不排序

      let params = {
        advert_id: this.bannersData[index].advert_id
      }
      if(index === 0) {
        params.next_advert_id = this.bannersData[index+1].advert_id
      }
      else {
        params.prev_advert_id = this.bannersData[index-1].advert_id
      }
      // else {
      //   params.next_advert_id = this.bannersData[index+1].advert_id
      //   params.prev_advert_id = this.bannersData[index-1].advert_id
      // }
      this.network().orderAdvert(params)
    },
    handlerRowClick({ advert_id }) {
      this.$router.push({
        path: '/administration/web/content/banner/detail',
        query: {
          id: advert_id
        }
      })
    },
    onNewBanner() {
      this.$router.push({
        path: '/administration/web/content/banner/detail'
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.news-container {
    .content-container {
        position: relative;
        .el-table {
          padding-top: 15px;
        }
        .btn-list {
          text-align: center;
          span {
            margin-right: 10px;
          }
        }
        .filter-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .filter-list {
            display: flex;
            .el-select {
              margin-right: 15px;
              width: 130px;
            }
          }
        }
      }
      .dialog-container {
    padding: 15px;
  }
  .ic-order {
      .svg-inline--fa {
          color: #91939A;
      font-size: 12px;
      } 
  }
  .img-banner {
      width: 150px;
  }
  .transparent {
    margin-top: 30px;
  }
}
</style>